import {useState} from 'react';
import {ArrowUpRight,Download,FileText,Presentation,Sprout,ConciergeBell,Factory,HardHat,Utensils} from 'lucide-react';
import {TechText} from './TechText';
import '../styles/profile-hub.css';
// Canva profile / presentation library (links supplied by the owner).
type Item={label:string;url:string;tag?:string};
const LANG:Item[]=[
 {label:'Tiếng Việt',tag:'VN',url:'https://canva.link/chy385aselwz8hq'},
 {label:'English',tag:'EN',url:'https://canva.link/5mie4metz8c76dh'},
 {label:'Deutsch',tag:'DE',url:'https://canva.link/fvqckq6wr5cbvft'},
 {label:'Ελληνικά',tag:'GR',url:'https://canva.link/b1p1xr2uqt50eig'}
];
const PRES:Item[]=[
 {label:'Tiếng Việt',tag:'VN',url:'https://canva.link/86revkse4cpcwt1'},
 {label:'English',tag:'EN',url:'https://canva.link/s42o6pga5363dfj'},
 {label:'Deutsch',tag:'DE',url:'https://canva.link/s098fu0xr2w0117'}
];
const SECTORS:Array<Item&{icon:typeof Sprout}>=[
 {label:'Nông nghiệp',tag:'AGRICULTURE',url:'https://canva.link/qu5tqczp9f4rmeb',icon:Sprout},
 {label:'Khách sạn - Nhà hàng',tag:'HOSPITALITY',url:'https://canva.link/bs7ei5k9rgeids3',icon:ConciergeBell},
 {label:'Nhà máy sản xuất',tag:'FACTORY',url:'https://canva.link/03w6d3z40e4rcw6',icon:Factory},
 {label:'Xây dựng',tag:'CONSTRUCTION',url:'https://canva.link/56m1arwrnjffusg',icon:HardHat},
 {label:'Chế biến thực phẩm',tag:'PROCESSING FOOD',url:'https://canva.link/rjtd0na6a2xhsis',icon:Utensils}
];
const Link=({href,children,className=''}:{href:string;children:React.ReactNode;className?:string})=><a href={href} target="_blank" rel="noopener noreferrer" className={className}>{children}</a>;

export function ProfileHub(){
 const [tab,setTab]=useState<'profile'|'present'|'sector'>('profile');
 return <section className="ph" aria-label="Hồ sơ năng lực NIBELC">
  <i className="ph-grid" aria-hidden="true"/><i className="ph-orb" aria-hidden="true"/>
  <header className="ph-head">
   <TechText className="ph-kicker" text="// PROFILE LIBRARY" speed={26}/>
   <h2>Tải hồ sơ năng lực<br/><em>NIBELC Group.</em></h2>
   <p>Bộ hồ sơ giới thiệu và bài trình bày theo ngôn ngữ và theo ngành, mở trực tiếp trên Canva ở tab mới.</p>
  </header>
  <div className="ph-tabs" role="tablist" aria-label="Loại tài liệu">
   {([['profile','Profile theo ngôn ngữ',FileText],['present','Presentation',Presentation],['sector','Profile theo ngành',Factory]] as const).map(([k,l,Icon])=>
    <button key={k} role="tab" type="button" aria-selected={tab===k} className={tab===k?'is-on':''} onClick={()=>setTab(k)}><Icon size={16}/>{l}</button>)}
  </div>
  <div className="ph-grid-cards" key={tab}>
   {tab==='profile'&&LANG.map((i,n)=><Link key={i.url} href={i.url} className="ph-card" ><span className="ph-tag">{i.tag}</span><strong>Profile NIBELC</strong><em>{i.label}</em><span className="ph-go"><Download size={16}/>Mở hồ sơ<ArrowUpRight size={16}/></span><i style={{animationDelay:n*80+'ms'}}/></Link>)}
   {tab==='present'&&PRES.map((i,n)=><Link key={i.url} href={i.url} className="ph-card"><span className="ph-tag">{i.tag}</span><strong>NIBELC Presentation</strong><em>{i.label}</em><span className="ph-go"><Presentation size={16}/>Xem bài trình bày<ArrowUpRight size={16}/></span><i style={{animationDelay:n*80+'ms'}}/></Link>)}
   {tab==='sector'&&SECTORS.map((i,n)=>{const Icon=i.icon;return <Link key={i.url} href={i.url} className="ph-card ph-sector"><Icon size={26} className="ph-ico"/><span className="ph-tag">{i.tag}</span><strong>{i.label}</strong><span className="ph-go"><Download size={16}/>Mở hồ sơ ngành<ArrowUpRight size={16}/></span><i style={{animationDelay:n*80+'ms'}}/></Link>})}
  </div>
 </section>;
}
